<template>
    <table class="mx-auto table-border page">
        <thead>
            <tr>
                <th>STT</th>
                <th>Phòng</th>
                <th>Mã hình</th>
                <th>Tình trạng</th>
                <th>Giá</th>
                <th>SDT</th>
                <th v-if="room_status !== 1">Ngày Báo Trả</th>
                <th v-else>Ngày hẹn nhận phòng</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(room_data, index) in items" :key="room_data.room_id">
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-center']">{{ index + 1 }}</td>
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-center']">{{ room_data.room_id }}</td>
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-center']">{{ room_data.picture_description }}</td>
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-no-wrap text-center']">
                    <span v-if="!room_data.room_status">
                        {{ room_data.status_text }} {{ room_data.is_included_air_conditioner || room_data.is_current_ac ? "CÓ MÁY LẠNH" : ""}}
                    </span>
                    <span v-else>
                        {{ room_data.date_schedule_out | formatTimeServer}} {{ room_data.is_included_air_conditioner || room_data.is_current_ac ? " (ML)" : ""}}
                    </span>
                </td>
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-no-wrap text-right']">{{ room_data.room_price | formatNumber}}</td>
                <td :class="[!room_data.room_status ? 'red--text' : '', 'text-no-wrap']">{{ room_data.phone }}</td>
                <td v-if="room_status !== 1" :class="[!room_data.room_status ? 'red--text' : '', 'text-no-wrap']">{{ room_data.date_schedule_out | formatTimeServer}}</td>
                <td v-else :class="[!room_data.room_status ? 'red--text' : '', 'text-no-wrap']">{{ room_data.date_schedule_in | formatTimeServer}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "print-tinh-trang-phong",
    props: {
        items: { type: Array, default: []},
        room_status: Number
    },
    data(){
        return {}
    }
};
</script>

<style>
</style>